'use client'

import React, { useEffect, useState } from 'react'
import { apmRum } from '@/apm-rum'
import CheckSocialLogin from '@/src/components/misc/check-social-login/check-social-login'
import Pixel from '../helpers/manager-scripts/facebook/pixel'
import Gtm from '../helpers/manager-scripts/google/gtm'
import { useSearchParams } from 'next/navigation'
import FullProduct from '../components/product/full-product/full-product'
import { DB_CACHE_NAME, MERCHANT_STORE_NAME } from '../constants/defaults'
import CacheHelper from '../core/cache/cache-helper'
import { usePromotion } from '../context/promotion/promotion-context'
import packageJson from '../../package.json'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { CookieNameEnum } from '../constants/cookie-names'
import MerchantDb from '../core/merchant-db'
import CheckCoupon from '../components/misc/check-coupon/check-coupon'
import { useShoppingCart } from '../context/shopping-cart/shopping-cart-context'

export default function InitClientScripts() {
    const searchParams = useSearchParams()
    const { promotion } = usePromotion()
    const { shoppingCart } = useShoppingCart()

    const productId = searchParams.get('item')
    const productName = searchParams.get('produto')

    const [canShowModal, setCanShowModal] = useState(false)

    const deleteMerchantDetailsStore = async () => {
        try {
            const db = await MerchantDb.getDB()
            if (!db) return

            const tx = db.transaction(MERCHANT_STORE_NAME, "readwrite")
            await tx.store.delete('merchant_details')
            await tx.done
        }
        catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        console.log("APM RUM Initialized:", apmRum)

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'F5' && e.ctrlKey) {
                CacheHelper.deleteDatabase(DB_CACHE_NAME)
                deleteCookie(CookieNameEnum.MerchantSummary)
                deleteMerchantDetailsStore()
            }
        }

        window.addEventListener('keydown', handleKeyDown);

        if (productId && productName)
            setCanShowModal(true)

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [])

    useEffect(() => {
        const version = getCookie(CookieNameEnum.AppVersion)

        if (version !== packageJson.version) {
            CacheHelper.deleteDatabase(DB_CACHE_NAME)
            setCookie(CookieNameEnum.AppVersion, packageJson.version)
        }
    }, [])

    return (
        <>
            {
                (canShowModal && promotion) &&
                <FullProduct
                    id={productId!}
                    name={productName!}
                    isOpen={true}
                    onClose={() => setCanShowModal(false)}
                />
            }
            <Gtm />
            <Pixel />
            <CheckSocialLogin />
            {shoppingCart && <CheckCoupon />}
        </>
    )
}
